import { render } from "./quickReply.vue?vue&type=template&id=54d0f7b7"
import script from "./quickReply.vue?vue&type=script&lang=js"
export * from "./quickReply.vue?vue&type=script&lang=js"

import "./quickReply.vue?vue&type=style&index=0&id=54d0f7b7&lang=scss"
script.render = render

export default script